import { render, staticRenderFns } from "./AuditStatisticsModal.vue?vue&type=template&id=287c59c9"
import script from "./AuditStatisticsModal.vue?vue&type=script&lang=js"
export * from "./AuditStatisticsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports